<app-page-heading [key]="'administration.reports-configuration.page-title'"></app-page-heading>

<section class="container summary-panel">
    <div class="row">
        <div class="col-6 col-sm-8">
            <div class="ibox float-e-margins">
                <div class="ibox-title">
                    <h2 class="handover-title" [i18n]="[{target: 'innerHTML', key: 'administration.reports-configuration.home-report.title'}]"></h2>
                </div>
                <div class="ibox-content">
                    <label for="homeReport" [i18n]="[{target: 'innerHTML', key: 'administration.reports-configuration.home-report.select'}]"></label>
                    <select id="homeReport" [(ngModel)]="homeReport" class="form-control" (change)="changeHomeReport()" [compareWith]="equalsRegionsId">
                        <option  *ngFor="let r of reports" [ngValue]="r">{{r.name}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="col-6 col-sm-4">
            <button class="btn btn-primary btn-lg pull-right" (click)="goToNewReport()">
                <span class="fa fa-plus"></span> <span [i18n]="[{target: 'innerHTML', key: 'administration.reports-configuration.buttons.new'}]"></span>
            </button>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="ibox float-e-margins">
                <div class="ibox-title">
                    <h2 class="handover-title" [i18n]="[{target: 'innerHTML', key: 'administration.reports-configuration.table.title'}]"></h2>
                </div>
                <div class="ibox-content no-padding">
                    <div class="table-responsive">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th [i18n]="[{target: 'innerHTML', key: 'administration.reports-configuration.table.name'}]"></th>
                                <th [i18n]="[{target: 'innerHTML', key: 'administration.reports-configuration.table.allowed-regions'}]"></th>
                                <th [i18n]="[{target: 'innerHTML', key: 'administration.reports-configuration.table.report-id'}]"></th>
                                <th [i18n]="[{target: 'innerHTML', key: 'administration.reports-configuration.table.edit'}]"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let r of pageReports">
                                <td>{{r.name}}</td>
                                <td>
                                    <span class="region-name" *ngFor="let region of r.assignedRegions">
                                        {{region.name}}
                                    </span>
                                </td>
                                <td>{{r.powerBiId}}</td>
                                <td>
                                    <button class="btn btn-outline-secondary btn-sm" (click)="updateReport(r.id)">
                                        <i class="fa fa-edit"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr *ngIf="!pageReports || pageReports.length === 0">
                                <td [attr.colspan]="4" class="force-text-center">
                                    <em [i18n]="[{target: 'innerHTML', key: 'administration.reports-configuration.table.no-report'}]">
                                    </em>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <app-pagination [items]="reports" [(pageItems)]="pageReports"></app-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
